import { InjectionToken } from '@angular/core';
import { IFicScreenConfig } from './fic-screen';
import { FicScreenRefModel } from './fic-screen-ref';

export const FicScreenConfig = new InjectionToken<IFicScreenConfig<any, any>>('FicScreenConfig');
export const FicScreenRef = new InjectionToken<FicScreenRefModel<any, any>>('FicScreenRef');
